<template>
  <modal @close="close">
    <h3 slot="header">{{ title }}</h3>

    <form id="concept_form" @submit.prevent="saveConcept" slot="body">
      <div class="md-layout">
        <md-field class="md-layout-item md-size-100" :class="validationClass('detailId')">
          <label for="detailId">Detalle</label>
          <md-select
            data-vv-name="detailId"
            v-validate="modelValidations.detailId"
            v-model="updatedConcept.detailId"
          >
            <md-option
              v-for="detail in details"
              :key="detail.id"
              :value="detail.id"
            >{{ detail.name }}</md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout">
        <md-field class="md-layout-item md-size-100" :class="validationClass('name')">
          <label for="name">Nombre</label>
          <md-input
            data-vv-name="name"
            v-validate="modelValidations.name"
            v-model="updatedConcept.name"
          ></md-input>
        </md-field>
      </div>
      <div class="md-layout">
        <md-field class="md-layout-item md-size-50" :class="validationClass('unitMeasurementId')">
          <label for="unitMeasurementId">Unidad de medida</label>
          <md-select
            data-vv-name="unitMeasurementId"
            v-validate="modelValidations.unitMeasurementId"
            v-model="updatedConcept.unitMeasurementId"
          >
            <md-option
              v-for="unit in measurementUnits"
              :key="unit.id"
              :value="unit.id"
            >{{ unit.name }}</md-option>
          </md-select>
        </md-field>
        <md-field
          class="md-layout-item md-size-50"
          :class="validationClass('code')"
          v-show="!!updatedConcept.id"
        >
          <label for="code">Codigo</label>
          <md-input
            data-vv-name="code"
            v-validate="modelValidations.code"
            v-model="updatedConcept.code"
            disabled
          ></md-input>
        </md-field>
      </div>
      <md-field :class="validationClass('comment')">
        <label for="comment">Comentario</label>
        <md-input
          data-vv-name="comment"
          v-validate="modelValidations.comment"
          v-model="updatedConcept.comment"
        ></md-input>
      </md-field>
      <md-field :class="validationClass('description')">
        <label for="description">Descripcion</label>
        <md-textarea
          data-vv-name="description"
          v-validate="modelValidations.description"
          v-model="updatedConcept.description"
        ></md-textarea>
      </md-field>

      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <md-divider class="md-inset" />
          <h5>Precio</h5>
        </div>

        <md-field class="md-layout-item md-size-33" :class="validationClass('unitPriceMXN')">
          <label for="unit_price_MXN">MXN</label>
          <md-input
            data-vv-name="unitPriceMXN"
            v-validate="modelValidations.unitPriceMXN"
            v-model="updatedConcept.unitPriceMXN"
          ></md-input>
        </md-field>
        <md-field class="md-layout-item md-size-33" :class="validationClass('unitPriceUSD')">
          <label for="unit_price_USD">USD</label>
          <md-input
            data-vv-name="unitPriceUSD"
            v-validate="modelValidations.unitPriceUSD"
            v-model="updatedConcept.unitPriceUSD"
          ></md-input>
        </md-field>
        <md-field class="md-layout-item md-size-33" :class="validationClass('unitPriceEUR')">
          <label for="unit_price_EUR">EUR</label>
          <md-input
            data-vv-name="unitPriceEUR"
            v-validate="modelValidations.unitPriceEUR"
            v-model="updatedConcept.unitPriceEUR"
          ></md-input>
        </md-field>
        <md-field class="md-layout-item md-size-33" :class="validationClass('basePrice')">
          <label for="base_price">Sin mano de obra</label>
          <md-input
            data-vv-name="basePrice"
            v-validate="modelValidations.basePrice"
            v-model="updatedConcept.basePrice"
          ></md-input>
        </md-field>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <md-checkbox v-model="updatedConcept.internal_concept">Concepto interno</md-checkbox>
        </div>
      </div>
    </form>

    <template slot="footer">
      <md-button
        type="submit"
        class="md-primary"
        form="concept_form"
      >{{ !concept.id ? "Guardar" : "Actualizar" }}</md-button>
    </template>
  </modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "RoadConceptForm",

  props: {
    concept: Object,
    details: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapState("catalogs", {
      measurementUnits: (s) => s["common/unit_measurement"],
    }),
  },

  data() {
    return {
      title: "Concepto Carretero",
      updatedConcept: {},
      modelValidations: {
        detailId: { required: true },
        name: { required: true },
        code: { required: false },
        comment: { required: true },
        unitMeasurementId: { required: true },
        description: { required: true },
        unitPriceMXN: { numeric: false, required: true },
        unitPriceUSD: { numeric: false },
        unitPriceEUR: { numeric: false },
        basePrice: { numeric: false },
      },
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },
    saveConcept() {
      const event = this.concept.id ? "updated" : "saved";
      const payload = { original: this.concept, updated: this.updatedConcept };
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit(event, payload);
        }
      });
    },
  },

  created() {
    this.updatedConcept = { ...this.concept };
  },

  mounted() {
    this.watchTouched({
      concept: Object.keys(this.modelValidations),
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Catalogs/RoadConceptsAdvance/RoadConceptForm.vue